import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Col, Row, Card, Spinner } from "reactstrap";

// import images
import bgImage from "../../assets/images/bgImage1.jpg";
import TrueFocus from "pages/Ui/React-blits/TrueFocus";
import Logo from "../../assets/images/logo.png";
import LogoNew from "../../assets/images/TitleMiner TM.png";

//split text
import SplitText from "pages/Ui/React-blits/SplitText";
import { useForm } from "react-hook-form";

//header
import Header from "components/VerticalLayout/Header";
import useRegister from "./useRegister";

const Login3 = () => {
  const navigate = useNavigate();

  const {isPending,signIn,error} = useRegister();

  //react hook form
  const{register, handleSubmit,formState :{errors},reset,getValues, trigger} = useForm({
    defaultValues:{
      firstName:"",
      lastName:"",
      companyName:"",
      email:"",
      phone:""
      }
  });

  //submit form
  const handleFormSubmit = async (data)=>{
    const isValid = await trigger(["firstName","lastName","companyName","email","phone"])

    if(isValid){
      // console.log("on handle form:",data)
      // e.preventDefault();
      signIn(data)
    }
  }

  document.title = "Login | Title Miner";
  return (
    <React.Fragment>
      <Header/>
      <div className="account-pages" style={{paddingTop:"35px"}}>
        <div className="accountbg"
          style={{
            background: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity:"0.9"
          }}>
        </div>

        <div> 
        <Card style={{ height: "100vh", display: "flex", borderRadius:"15px", margin:"40px", borderColor:"black", borderWidth:"1.5px",backgroundImage:`url(${bgImage})`}}>
          <Row style={{height:"100%"}}>
            <Col md={6} style={{ display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center",borderWidth:"10px", borderColor:"black"}}>
              <TrueFocus borderColor="#00ADF0"/>
            </Col>

            <Col md={6}  className="d-flex flex-column justify-content-center align-items-center">
            <div style={{backgroundColor:"white", borderRadius:"10px", width:"90%", height:"90%"}}>
              <div className="text-center mt-3 pt-3">
              {/* <img className="img-fluid" src={LogoNew} alt="TrueFocus Automation" style={{width:"350px"}}/> */}
              Title Appraiser Logo
            </div>
            <p className="text-muted text-center fs-6 pt-3">
              {/* Experience Title Miner™ - Start your free trial today! */}
            </p>

          <form className="mt-1 p-1 m-4" onSubmit={handleSubmit(handleFormSubmit)}>

            <div className="mb-2">
              <label htmlFor="email" className="form-label">Email</label>
              <input
                type="email"
                className="form-control border-primary-subtle"
                id="email"
                name="email"
                placeholder="Email here..."

                {...register("email",{required:"Valid email required",
                  minLength: {value: 6, message: "Email must have atleast 6 characters"},
                  pattern:{value: /^\S+@\S+\.\S+$/, message:"Invalid email format"}
                })}
              />
              { errors.email && <span className="text-danger">{errors.email.message}</span>}
            </div>

            <div className="mb-3">
              <label htmlFor="phone" className="form-label">Phone Number</label>
              <input
                type="tel"
                className="form-control border-primary-subtle"
                id="phone"
                name="phone"
                placeholder="Phone number here..."
                // value={phoneNumber}
                // onChange={(e)=> setPhoneNumber(e.target.value)}
                {...register("phone",{required:"Phone number required",
                  pattern:{value:/^\+?[1-9][0-9]{7,14}$/, message: "Valid phone number required"},
                  minLength:{value: 7, message:"Phone number must be atleast 8 digits long"},
                  maxLength:{value: 15, message: "Phone number cannot exceed 15 digits"}
                })}
              />
              { errors.phone && <span className="text-danger">{errors.phone.message}</span>}
            </div>

            <button type="submit" disabled={isPending} className="btn  w-100 py-2" style={{backgroundColor:"#00ADF0", color:"white"}}>
              {isPending ? <Spinner type="grow" color="secondary" size="sm"/> : "Sign In"}
            </button>
          </form>
          <div className="text-center mt-2 pt-2 ">
              © {new Date().getFullYear()} TrueFocus Automation.All rights reserved.
          </div>
        </div>
            </Col>
          </Row>
        </Card>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Login3;
